/**
 * Captures a DOM element and returns the PDF as an ArrayBuffer.
 * Produces crisp, high-quality, lightweight PDFs (under 1MB) suitable for email attachment and download.
 */
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export async function generateDocPdf(element) {
  if (!element) return null;

  const canvas = await html2canvas(element, {
    scale: 1.8,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    windowWidth: element.scrollWidth || 800,
  });

  const pdf = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    compress: true,
  });

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  // High quality JPEG (0.90 quality) compresses payload by 85-90% while keeping text crystal clear
  const imgData = canvas.toDataURL('image/jpeg', 0.90);
  const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, imgHeight, undefined, 'FAST');
  heightLeft -= pdfHeight;

  while (heightLeft > 5) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, imgHeight, undefined, 'FAST');
    heightLeft -= pdfHeight;
  }

  return pdf.output('arraybuffer');
}
